function getYPos(node) {
    return window.scrollY + node.getBoundingClientRect().top;
}

function inViewport(node) {
    return node.getBoundingClientRect().top > 0;
}

function isChild(parent, child) {
    return child.parentNode === parent;
}

function updateScrollPosition(tab) {
    if (!inViewport(tab)) {
        window.scrollTo({
            top: getYPos(tab) - 200,
            left: 0,
            behavior: 'smooth'
        });
    }
}

function isOpen(tab) {
    return tab.classList.contains('accordion__button--active');
}

function isChildOfTab(tab, child) {
    const panel = tab.nextElementSibling; 

    return panel.contains(child);
}

function getTabHeight(tab) {
    const content = tab.nextElementSibling.querySelector('.js_accordion__contentWrap');

    if (content) {
        return content.scrollHeight;
    }

    return 0;
}

function getMinAccordionHeight(accordion) {
    const tabs = getTabs(accordion);
    const marginBottom = 20;

    return tabs.map(tab => tab.scrollHeight + marginBottom).reduce((height1, height2) => height1 + height2, 0);
}

function getMaxAccordionHeight(accordion) {
    const tabs = getTabs(accordion);

    const maxOpenTabHeight = Math.max(...tabs.map(getTabHeight));
    const minAccordionHeight = getMinAccordionHeight(accordion);

    return minAccordionHeight + maxOpenTabHeight;
}

function openTab(tab, accordions) {
    tab.classList.add('accordion__button--active');

    resizeTab(tab, accordions);
}

function closeTab(tab) {
    tab.classList.remove('accordion__button--active');
    
    const panel = tab.nextElementSibling;

    panel.style.maxHeight = null;
    panel.style.overflow = 'hidden';
}

function handleClick(tab, tabs, accordions) {

    if (isOpen(tab)) {
        closeTab(tab);
    } else {
        openTab(tab, accordions);
        tabs.filter(t => t !== tab).forEach(closeTab);
    }

    setTimeout(() => updateScrollPosition(tab), 200);
}

function getTabs(accordion) {
    const tabs = Array.from(accordion.getElementsByClassName('js_accordion__button'));

    return tabs.filter(tab => isChild(accordion, tab));
}

function resizeTab(tab, accordions) {
    const childAccordions = accordions.filter(accordion => isChildOfTab(tab, accordion));
    const maxChildAccordionHeight = Math.max(0, ...childAccordions.map(getMaxAccordionHeight));
    
    const panel = tab.nextElementSibling;
    const tabHeight = getTabHeight(tab);

    panel.style.maxHeight = tabHeight + maxChildAccordionHeight + 'px';
    panel.style.overflow = 'visible';
}

function resizeAccordion(accordion, accordions) {
    const tabs = getTabs(accordion);

    tabs.filter(isOpen).forEach(tab => resizeTab(tab, accordions));
}

function initAccordion(accordion, accordions) {
    const tabs = getTabs(accordion);

    tabs.forEach(tab => tab.addEventListener('click', e => handleClick(tab, tabs, accordions)));

    tabs.filter(isOpen).forEach(tab => openTab(tab, accordions));
}

function init() {
    $(document).ready(() => {
        const accordions = Array.from(document.getElementsByClassName('js_accordion'));

        accordions.forEach(accordion => initAccordion(accordion, accordions));

        window.addEventListener('resize', e => accordions.forEach(accordion => resizeAccordion(accordion, accordions)));
    });
}

export default init;
